import sectionCardDualImgCss from '../css-snippets/section-card-dual-img';

const html = `
<style>${sectionCardDualImgCss}</style>
   <div data-attribute="card-container" data-top-padding="true" data-bottom-padding="true">
        <div class="container-page" data-attribute="container-page">
            <div class="wrap-card container">
                <div data-attribute="card-item-content" data-order="1" class="card-left" data-style-center-y="false" style="order: 1;">
                    <h2 data-attribute="card-title" class="card-title">Flagship Dual Camera Model</h2>
                    <div data-attribute="card-description">
                        <p>Equipped with front and rear cameras for enhanced visibility and improved navigation during outdoor driving.</p>
                        <p>The model powering the <a href="https://earth-rover-challenge.github.io/" target="_blank" title="https://earth-rover-challenge.github.io/" class="js-no-transition">EarthRover Challenge</a>, AI vs. Human competition.</p>
                    </div>
                    <div data-attribute="card-btn-row" data-show-btn="true" class="row-btn" style="display: block;">
                        <a data-attribute="card-btn" class="card-btn" href="#">View More</a>
                    </div>
                </div>
                <div data-attribute="card-item-image" data-order="2" class="card-right" style="order: 2;">
                    <div data-attribute="list-image" class="list-image">
                        <div class="image-item">
                            <img loading="lazy" data-attribute="card-image" class="card-image" src="https://cdn.cacheimg.com/Admin-Lattehub/2025/08/11/image-6899b8292282d5538b84f50d.webp?w=300" alt="">
                        </div>
                        <div class="image-item">
                            <img loading="lazy" data-attribute="card-image" class="card-image" src="https://cdn.cacheimg.com/Admin-Lattehub/2025/08/11/image-6899b7b181352165d316f7b0.webp?w=300" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
`;
export default html;
